import React from 'react';
import PropTypes from 'prop-types';
import { Markup } from 'interweave';

import {
  ActionsCheckNormalSmall,
  ActionsCheckNormalMedium
} from '@strava/icons';
import { matchMedia } from '@strava/ui/MediaQuery';

import styles from './index.scss';

const ChecklistSection = ({ checklistSection }) => {
  const stravaOrangeHex = '#FC5200';
  const checkIcon = matchMedia.screenXs() ? (
    <ActionsCheckNormalSmall fill={stravaOrangeHex} />
  ) : (
    <ActionsCheckNormalMedium fill={stravaOrangeHex} />
  );

  return (
    <>
      <div className={`container ${styles.container} ${styles.desktop}`}>
        <div className={`${styles.row}`}>
          <p className={`${styles.headline2} ${styles.checklistHeadline}`}>
            {checklistSection.headline}
          </p>
        </div>
      </div>

      {/* <Markup> lets the marketers use &shy; to stragetically add hyphens 
      to break long words in mobile view */}
      <table className={styles.checklistTable}>
        <tr className={`${styles.row} ${styles.checklistRow}`}>
          <th className={`${styles.subtitle2} ${styles.checklistHeaders}`}>
            <Markup content={checklistSection.item_label} noWrap={true} />
          </th>
          <th className={`${styles.subtitle2} ${styles.checklistHeaders}`}>
            <Markup content={checklistSection.free_label} noWrap={true} />
          </th>
          <th className={`${styles.subtitle2} ${styles.checklistHeaders}`}>
            <Markup
              content={checklistSection.subscription_label}
              noWrap={true}
            />
          </th>
        </tr>
        {checklistSection.items.map((item) => (
          <tr
            className={`${styles.row} ${styles.checklistRow}`}
            key={item.text}
          >
            <td className={`${styles.body2}`}>{item.text}</td>
            <td className="text-center">{item.free && checkIcon}</td>
            <td className="text-center">{item.subscription && checkIcon}</td>
          </tr>
        ))}
      </table>
    </>
  );
};

ChecklistSection.propTypes = {
  checklistSection: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    item_label: PropTypes.string.isRequired,
    free_label: PropTypes.string.isRequired,
    subscription_label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        free: PropTypes.bool.isRequired,
        subscription: PropTypes.bool.isRequired
      })
    )
  }).isRequired
};

export default ChecklistSection;
